<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" label-width="230px" :rules="rules">

            <el-form-item label="配置项：" prop="key" v-show="editType == 0">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入配置项"
                    v-model="formData.key"
                    size="mini"
                ></el-input>
            </el-form-item>

            <el-form-item label="配置值：">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入配置值"
                    v-model="formData.value"
                    size="mini"
                    type="textarea" :rows="5"
                ></el-input>
            </el-form-item>

            <el-form-item label="描述：">
                <el-input
                    style="width: 300px;"
                    placeholder="请输入描述"
                    v-model="formData.description"
                    size="mini"
                    type="textarea" :rows="5"
                ></el-input>
            </el-form-item>

        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
            >确定
            </el-button>
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {keepa_keepa_root_category_index} from '@/api/advAnalys/advAnalys.js'

    export default {
        components: {},
        data() {
            return {
                loading: false,
                options: [],

                rules: {
                    key: [
                        {
                            required: true,
                            message: '请输入配置项',
                            trigger: 'blur'
                        },
                    ],
                    value: [
                        {
                            required: true,
                            message: '请输入配置值',
                            trigger: 'blur'
                        },
                    ],
                },
                formData: {
                    key: '',
                    value: '',
                    description: '',
                }
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            copyData: {
                type: Object,
                default: {}
            },
            editType: {
                type: Number,
                default: 0
            }
        },
        watch: {
            copyData: {
                handler(val) {
                    this.formData = val
                }
            }
        },
        methods: {
            submitForm() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        if (this.editType == 0) {
                            api.auth_config_add(this.formData).then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({message: '添加成功', type: 'success'})
                                    this.handleClose(true)
                                } else {
                                    this.$message({type: 'error', message: res.message})
                                }
                            }).catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message: '网络出现问题，请刷新页面！'
                                })
                            })
                        } else {
                            api.auth_config_edit(this.formData).then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({message: '修改成功', type: 'success'})
                                    this.handleClose(true)
                                } else {
                                    this.$message({type: 'error', message: res.message})
                                }
                            }).catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message: '网络出现问题，请刷新页面！'
                                })
                            })
                        }
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.formData = {
                    keepa_category_id: [],
                }
                this.$refs['formData'].resetFields()
                this.loading = false
                this.$emit('close-callback', isshow)
            },
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
